module.exports = __webpack_public_path__ + "img/person-check.035320e6.svg";